<ng-container *ngIf="loading">
  <mat-spinner color="primary" diameter="18"></mat-spinner>
</ng-container>
<ng-container *ngIf="!loading">
  <div
    class="association-picker"
    [ngClass]="
      showOtherSidePicker ? 'no-form-field-padding' : 'less-form-field-padding'
    "
  >
    <div>
      <div class="title">{{ pickerLabel }}</div>
      <mat-form-field appearance="outline">
        <mat-select
          matInput
          [(value)]="selectedOption"
          (selectionChange)="setOptionValue($event.value)"
        >
          <mat-option
            *ngFor="let option of associationOptions"
            [value]="option"
            >{{ option.label }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
    <div
      *ngIf="showOtherSidePicker || ipBoard.leftRightBoard"
      class="side-label left-label"
    >
      {{ label }}
    </div>
    <div
      *ngIf="
        selectedOption != null &&
        selectedOption.value === null &&
        !selectedOption.representsDefaultOption
      "
      class="other-value-input top-margin"
    >
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="{{ otherValuePlaceholder }}"
          [(ngModel)]="otherValue"
          (ngModelChange)="setOtherValue()"
        />
      </mat-form-field>
    </div>
  </div>
  <div
    *ngIf="showOtherSidePicker"
    class="association-picker less-form-field-padding"
  >
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        [(value)]="otherSideSelectedOption"
        (selectionChange)="setOtherOptionValue($event.value)"
      >
        <mat-option
          *ngFor="let option of associationOptions"
          [value]="option"
          >{{ option.label }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <div *ngIf="showOtherSidePicker" class="side-label">
      Rechts
    </div>
    <div
      *ngIf="
        otherSideSelectedOption != null &&
        otherSideSelectedOption.value === null &&
        !otherSideSelectedOption.representsDefaultOption
      "
      class="other-value-input"
    >
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="{{ otherValuePlaceholder }}"
          [(ngModel)]="otherSideOtherValue"
          (ngModelChange)="setOtherSideOtherValue()"
        />
      </mat-form-field>
    </div>
  </div>
  <div
    class="left-fifteen-space"
    *ngIf="
      canPickOtherOption &&
      ipBoardPart.boardType?.ordinal === BOARD_TYPE_CHOICES.V.ordinal &&
      !ipBoard.leftRightBoard
    "
  >
    <mat-checkbox
      [(ngModel)]="showOtherSidePicker"
      (ngModelChange)="showOtherSidePickerChanged()"
      ><span class="smaller-text"
        >Links/Rechts bord afzonderlijk v/e
        {{ otherSideCheckboxLabel }} voorzien</span
      ></mat-checkbox
    >
  </div>
</ng-container>
